import './style.scss';
import { InputTemplate, InputTemplateProps } from '../../../inputTemplate';
import { icons } from 'constants/icons';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';

type TitleProps = {
  title?: string;
};

export const Title = ({ title }: TitleProps) => {
  if (!!title === false) {
    return <></>;
  }
  return (
    <div className="bankModalModule title">
      <SvgIcon icon={icons.auroraBox} size={IconSize.icon_s} />
      <div className="bankModalModule title_label">{title}</div>
    </div>
  );
};

type MessageProps = {
  message?: string;
};
export const Message = ({ message }: MessageProps) => {
  if (!!message === false) {
    return <></>;
  }
  return <div className="bankModalModule message_label radiusType_round">{message}</div>;
};
type SelectedProps = {
  bankName?: string;
};
export const Selected = ({ bankName }: SelectedProps) => {
  if (!!bankName === false) {
    return <></>;
  }
  return (
    <div className="bankModalModule selected">
      <div className="bankModalModule selected_label radiusType_sharp">{'金融機関名'}</div>
      <div className="bankModalModule selected_label radiusType_sharp backgroundColor_main">{bankName}</div>
    </div>
  );
};

type BankInputType = {
  inputTemplete: InputTemplateProps;
  title: string;
  comment?: string;
  example: string;
  onSearch?: () => void;
};
export const BankInput = ({ inputTemplete, title, comment, example, onSearch }: BankInputType) => {
  return (
    <div className="bankModalModule card">
      {title}
      <div className="bankModalModule card_comment">{comment}</div>
      <div className="bankModalModule card_baseLayout">
        <div className="bankModalModule card_input">
          <InputTemplate {...inputTemplete} />
        </div>
        <div className="bankModalModule card_button">
          <Button
            type={ButtonType.Submit}
            label={'検索'}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.xsmall}
            onClick={onSearch}
          />
        </div>
      </div>
      {example}
    </div>
  );
};

export enum BankButtonType {
  none,
  backOnly,
  backAndNext,
}

export type BankButtonProps = {
  type: BankButtonType;
  back?: () => void;
  disabled?: boolean;
};

export const BankButton = ({ type, back, disabled }: BankButtonProps) => {
  switch (type) {
    case BankButtonType.backOnly:
      return (
        <div className="bankModalModule buttons single">
          <div className="bankModalModule link" onClick={back}>
            {'もどる'}
          </div>
        </div>
      );
    case BankButtonType.backAndNext:
      return (
        <div className="bankModalModule buttons double">
          <div className="bankModalModule link" onClick={back}>
            {'もどる'}
          </div>
          <Button
            type={ButtonType.Submit}
            label={'選択する'}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.xsmall}
            disable={disabled}
          />
        </div>
      );
    case BankButtonType.none:
    default:
      return <></>;
  }
};
